import { REMOVED_HUB_SLUGS, REMOVED_PAGE_SLUGS } from '../constants/pageSlugs'

const HOME_ITEM = {
  id: 'home',
  title_en: 'Home',
  title_ar: 'الرئيسية',
  slug: null,
  url: '/',
}

function isRemovedHub(slug) {
  return slug && REMOVED_HUB_SLUGS.includes(slug)
}

function isRemovedPage(slug) {
  return slug && REMOVED_PAGE_SLUGS.includes(slug)
}

function mapChild(child) {
  if (isRemovedPage(child.slug)) return null

  const nestedChildren = (child.children || []).map(mapChild).filter(Boolean)

  return {
    ...child,
    url: child.url || (child.slug ? `/pages/${child.slug}` : null),
    ...(nestedChildren.length ? { children: nestedChildren } : {}),
  }
}

export function isInlineMenuGroup(item) {
  return item.children?.length > 0 && !item.children.some((child) => child.children?.length)
}

export function childMenuUrl(child) {
  if (child.url) return child.url
  return child.slug ? `/pages/${child.slug}` : null
}

export function isMenuItemActive(item, pathname) {
  const url = childMenuUrl(item)
  if (url && pathname === url) return true
  return (item.children || []).some((child) => isMenuItemActive(child, pathname))
}

function mapTab(tab) {
  const hubRemoved = isRemovedHub(tab.slug)

  return {
    id: tab.id,
    title_en: tab.title_en,
    title_ar: tab.title_ar,
    slug: hubRemoved ? null : tab.slug,
    url: hubRemoved ? null : tab.url || (tab.slug ? `/pages/${tab.slug}` : '/'),
    children: (tab.children || []).map(mapChild).filter(Boolean),
  }
}

/**
 * Build navigation from API menu tree.
 * Top-level tabs include nested sub-pages as children.
 */
export function buildNavItems(menuTree) {
  if (!Array.isArray(menuTree) || menuTree.length === 0) {
    return null
  }

  const items = [HOME_ITEM, ...menuTree.map(mapTab)]

  return items
}

export const WE_ARE_MAYAR_SLUG = 'WeAreMayar'

export const WE_ARE_MAYAR_CHILDREN = [
  { id: 'ceo', slug: 'MessageFromCEO', title_en: 'Message From CEO', title_ar: 'رسالة من الرئيس التنفيذي' },
  { id: 'lead', slug: 'Leadership', title_en: 'Leadership Team', title_ar: 'فريق القيادة' },
  { id: 'vmv', slug: 'VisionMissionValues', title_en: 'Vision, Mission & Core Values', title_ar: 'الرؤية والرسالة والقيم' },
  { id: 'acc', slug: 'Accreditations', title_en: 'Accreditations', title_ar: 'الاعتمادات' },
  { id: 'part', slug: 'CommunityPartnerships', title_en: 'Community Partnerships', title_ar: 'شراكات المجتمع' },
  { id: 'council', slug: 'StudentCouncil', title_en: 'Student Council', title_ar: 'المجلس الطلابي' },
  {
    id: 'weekly-schedule',
    slug: 'WeeklySchedule412',
    title_en: 'Weekly Schedule (4-12)',
    title_ar: 'التوزيع الزمني الأسبوعي (4-12)',
  },
  { id: 'careers', slug: 'Careers', url: '/careers', title_en: 'Careers', title_ar: 'الوظائف' },
].map(mapChild)


export const DEFAULT_WE_ARE_MAYAR = {
  id: 'WeAreMayar',
  title_en: 'About',
  title_ar: 'عن ميار',
  slug: null,
  url: null,
  children: WE_ARE_MAYAR_CHILDREN,
}

export const OUR_COMMITMENT_SLUG = 'OurCommitment'

const LEARNING_GROWTH_LINKS = [
  { id: 'diff', slug: 'MayarDifference', title_en: 'The Mayar Difference', title_ar: 'تميز ميار' },
  { id: 'academic', slug: 'AcademicExcellence', title_en: 'Academic Excellence', title_ar: 'التميز الأكاديمي' },
  { id: 'beyond', slug: 'BeyondClassroom', title_en: 'Beyond the Classroom', title_ar: 'ما وراء الفصل الدراسي' },
  { id: 'uni', slug: 'UniversityCareerPathways', title_en: 'University & Career Pathways', title_ar: 'المسارات الجامعية والمهنية' },
  { id: 'real', slug: 'RealWorldReadiness', title_en: 'Real World Readiness', title_ar: 'الاستعداد للعالم الحقيقي' },
].map(mapChild)

const CARE_SUPPORT_LINKS = [
  { id: 'values', slug: 'ValuesCharacter', title_en: 'Values & Character', title_ar: 'القيم والشخصية' },
  { id: 'wellbeing', slug: 'WellbeingCounseling', title_en: 'Wellbeing & Counseling', title_ar: 'الرفاهية والإرشاد' },
  { id: 'inclusion', slug: 'InclusionLearningSupport', title_en: 'Inclusion & Learning Support', title_ar: 'الدمج والدعم التعليمي' },
  { id: 'safety', slug: 'StudentSafety', title_en: 'Student Safety & Care', title_ar: 'سلامة ورعاية الطلاب' },
  { id: 'arabic', slug: 'ArabicNonNative', title_en: 'Arabic for Non-Native Speakers', title_ar: 'العربية لغير الناطقين بها' },
  { id: 'sustain', slug: 'Sustainability', title_en: 'Sustainability & Responsibility', title_ar: 'الاستدامة والمسؤولية' },
].map(mapChild)

export const OUR_COMMITMENT_CHILDREN = [
  {
    id: 'learning-growth',
    slug: 'LearningGrowth',
    title_en: 'Learning & Growth',
    title_ar: 'التعلم والنمو',
    children: LEARNING_GROWTH_LINKS,
  },
  {
    id: 'care-support',
    slug: 'CareSupport',
    title_en: 'Care & Support',
    title_ar: 'الرعاية والدعم',
    children: CARE_SUPPORT_LINKS,
  },
].map(mapChild).filter(Boolean)

export const DEFAULT_OUR_COMMITMENT = {
  id: 'OurCommitment',
  title_en: 'Our Approach',
  title_ar: 'نهجنا التعليمي',
  slug: null,
  url: null,
  children: OUR_COMMITMENT_CHILDREN,
}

export const OUR_SCHOOLS_SLUG = 'OurSchools'

const SCHOOLS_PROGRAM_LINKS = [
  { id: 'national', slug: 'NationalProgram', title_en: 'National Program', title_ar: 'البرنامج الوطني' },
  { id: 'british', slug: 'BritishProgram', title_en: 'British Program', title_ar: 'البرنامج البريطاني' },
  { id: 'american', slug: 'AmericanProgram', title_en: 'American Program', title_ar: 'البرنامج الأمريكي' },
].map(mapChild)

export const OUR_SCHOOLS_CHILDREN = [
  {
    id: 'programs',
    slug: 'Programs',
    title_en: 'Programs',
    title_ar: 'البرامج',
    url: '/programs',
    children: SCHOOLS_PROGRAM_LINKS,
  },
  {
    id: 'campuses',
    slug: 'Campuses',
    title_en: 'Campuses',
    title_ar: 'الحرم',
    url: '/pages/Campuses',
    children: [
      { id: 'tla', slug: 'MisTlaAlAli', title_en: 'Tla Al-Ali Campus', title_ar: 'حرم تلاع العلي' },
      { id: 'khalda', slug: 'MisKhalda', title_en: 'Khalda Campus', title_ar: 'حرم خلدا' },
    ].map(mapChild),
  },
].map(mapChild).filter(Boolean)

export const DEFAULT_OUR_SCHOOLS = {
  id: 'OurSchools',
  title_en: 'Our Schools',
  title_ar: 'مدارسنا',
  slug: null,
  url: null,
  children: OUR_SCHOOLS_CHILDREN,
}

export const OUR_STUDENTS_SLUG = 'OurStudents'

export const OUR_STUDENTS_CHILDREN = [
  { id: 'experiences', slug: 'StudentExperiences', title_en: 'Student Experiences', title_ar: 'تجارب الطلاب' },
  { id: 'alumni', slug: 'Alumni', title_en: 'Alumni', title_ar: 'خريجونا' },
].map(mapChild)

export const DEFAULT_OUR_STUDENTS = {
  id: 'OurStudents',
  title_en: 'Student Life',
  title_ar: 'حياة الطلاب',
  slug: null,
  url: null,
  children: OUR_STUDENTS_CHILDREN,
}

export const NEWS_EVENTS_SLUG = 'NewsEvents'

export const NEWS_EVENTS_CHILDREN = [
  { id: 'news', slug: 'News', title_en: 'News', title_ar: 'الأخبار', url: '/news' },
  { id: 'events', slug: 'SchoolEvents', title_en: 'School Events', title_ar: 'فعاليات المدرسة', url: '/events' },
].map(mapChild)

export const DEFAULT_NEWS_EVENTS = {
  id: 'NewsEvents',
  title_en: 'News & Events',
  title_ar: 'الأخبار والفعاليات',
  slug: null,
  url: null,
  children: NEWS_EVENTS_CHILDREN,
}

export const ADMISSIONS_SLUG = 'Admissions'

export const ADMISSIONS_CHILDREN = [
  { id: 'admission', slug: 'AdmissionRegistration', title_en: 'Admission & Registration', title_ar: 'القبول والتسجيل' },
  { id: 'certification', slug: 'TransferringCertification', title_en: 'Certificate Transfer', title_ar: 'تصديق الشهادات' },
].map(mapChild)

export const DEFAULT_ADMISSIONS = {
  id: 'Admissions',
  title_en: 'Admissions',
  title_ar: 'القبول والتسجيل',
  slug: null,
  url: null,
  children: ADMISSIONS_CHILDREN,
}

export const SCHOOL_DIVISIONS_SLUG = 'SchoolDivisions'

const DIVISION_KG_LINKS = [
  { id: 'kg-curriculum', slug: 'KgCurriculum', title_en: 'KG Curriculum', title_ar: 'مناهج الروضة' },
  { id: 'kg-schedule', slug: 'KgDailySchedule', title_en: 'KG Daily Schedule', title_ar: 'جدول الروضة' },
  { id: 'kg-about', slug: 'Kindergarten', title_en: 'Kindergarten', title_ar: 'مرحلة الروضة' },
  { id: 'kg-guidelines', slug: 'KgGuidelines', title_en: 'KG Guidelines', title_ar: 'إرشادات الروضة' },
].map(mapChild)

const DIVISION_PRIMARY_LINKS = [
  {
    id: 'early-primary',
    slug: 'EarlyPrimary',
    title_en: 'Grades 1–3',
    title_ar: 'الصفوف 1–3',
    children: [
      { id: 'ep-national', slug: 'EpNationalCurriculum', title_en: 'National Curriculum', title_ar: 'المنهاج الوطني' },
      { id: 'ep-timetables', slug: 'EpDailyTimetables', title_en: 'Daily Timetables', title_ar: 'جداول الحصص' },
      { id: 'ep-intl', slug: 'EpInternationalCurriculum', title_en: 'International Curriculum', title_ar: 'المنهاج الدولي' },
      { id: 'ep-guidelines', slug: 'EpGuidelines', title_en: 'Guidelines', title_ar: 'التعليمات والإرشادات' },
      { id: 'ep-assessment', slug: 'EpAssessmentPolicy', title_en: 'Assessment Policy', title_ar: 'سياسة التقييم' },
    ].map(mapChild),
  },
  {
    id: 'primary-46',
    slug: 'PrimaryGrades46',
    title_en: 'Grades 4–6',
    title_ar: 'الصفوف 4–6',
    children: [
      { id: 'pg-national', slug: 'PgNationalCurriculum', title_en: 'National Curriculum', title_ar: 'المنهاج الوطني' },
      { id: 'pg-intl', slug: 'PgInternationalCurriculum', title_en: 'International Curriculum', title_ar: 'المنهاج الدولي' },
      { id: 'pg-timetables', slug: 'PgDailyTimetables', title_en: 'Daily Timetables', title_ar: 'جداول الحصص' },
      { id: 'pg-guidelines', slug: 'PgGuidelines', title_en: 'Guidelines', title_ar: 'التعليمات والإرشادات' },
    ].map(mapChild),
  },
].map(mapChild)

const DIVISION_MIDDLE_LINKS = [
  { id: 'ms-national', slug: 'MsNationalCurriculum', title_en: 'National Curriculum (7–10)', title_ar: 'المنهاج الوطني (7–10)' },
  { id: 'ms-timetables', slug: 'MsDailyTimetables', title_en: 'Daily Timetables', title_ar: 'جداول الحصص' },
  { id: 'ms-intl', slug: 'MsInternationalCurriculum', title_en: 'International Curriculum (7–8)', title_ar: 'المنهاج الدولي (7–8)' },
  { id: 'ms-about', slug: 'AboutMiddleSchool', title_en: 'About Middle School', title_ar: 'عن المرحلة المتوسطة' },
  { id: 'ms-guidelines', slug: 'MsGuidelines', title_en: 'Guidelines', title_ar: 'التعليمات والإرشادات' },
].map(mapChild)

const DIVISION_HIGH_LINKS = [
  { id: 'hs-national', slug: 'HsNational', title_en: 'National (11–12)', title_ar: 'الوطني (11–12)' },
  {
    id: 'hs-british',
    slug: 'HsBritishProgram',
    title_en: 'British IGCSE (9–12)',
    title_ar: 'البريطاني (9–12)',
    children: [
      { id: 'hs-br-tawjihi', slug: 'HsBritishTawjihi', title_en: 'Tawjihi Equivalency', title_ar: 'معادلة التوجيهي' },
      { id: 'hs-br-curriculum', slug: 'HsBritishCurriculum', title_en: 'British Curriculum', title_ar: 'المنهاج البريطاني' },
    ].map(mapChild),
  },
  {
    id: 'hs-american',
    slug: 'HsAmericanProgram',
    title_en: 'American H.S.D (9–12)',
    title_ar: 'الأمريكي (9–12)',
    children: [
      { id: 'hs-am-tawjihi', slug: 'HsAmericanTawjihi', title_en: 'Tawjihi Equivalency', title_ar: 'معادلة التوجيهي' },
      { id: 'hs-am-curriculum', slug: 'HsAmericanCurriculum', title_en: 'American Curriculum', title_ar: 'المنهاج الأمريكي' },
    ].map(mapChild),
  },
].map(mapChild)

export const SCHOOL_DIVISIONS_CHILDREN = [
  {
    id: 'division-kg',
    slug: 'DivisionKindergarten',
    title_en: 'Kindergarten',
    title_ar: 'رياض الأطفال',
    children: DIVISION_KG_LINKS,
  },
  {
    id: 'division-primary',
    slug: 'DivisionPrimary',
    title_en: 'Primary',
    title_ar: 'المرحلة الأساسية',
    children: DIVISION_PRIMARY_LINKS,
  },
  {
    id: 'division-middle',
    slug: 'DivisionMiddleSchool',
    title_en: 'Middle School',
    title_ar: 'المرحلة المتوسطة',
    children: DIVISION_MIDDLE_LINKS,
  },
  {
    id: 'division-high',
    slug: 'DivisionHighSchool',
    title_en: 'High School',
    title_ar: 'المرحلة الثانوية',
    children: DIVISION_HIGH_LINKS,
  },
].map(mapChild).filter(Boolean)

export const DEFAULT_SCHOOL_DIVISIONS = {
  id: 'SchoolDivisions',
  title_en: 'Divisions',
  title_ar: 'الأقسام',
  slug: null,
  url: null,
  children: SCHOOL_DIVISIONS_CHILDREN,
}

export const FOR_PARENTS_SLUG = 'ForParents'

export const FOR_PARENTS_CHILDREN = [
  { id: 'choose', slug: 'ChoosingProgram', title_en: 'Choosing the Right Program', title_ar: 'اختيار البرنامج المناسب' },
  { id: 'pathways', slug: 'PathwaysChoices', title_en: 'Pathways & Choices', title_ar: 'المسارات والخيارات' },
  { id: 'app', slug: 'MayarApp', title_en: 'Mayar App', title_ar: 'تطبيق ميار' },
  { id: 'world', slug: 'MayarForWorld', title_en: 'Mayar for the World', title_ar: 'ميار للعالم' },
  { id: 'parents', slug: 'ParentTestimonials', title_en: 'What Parents Say', title_ar: 'ماذا يقول أولياء الأمور' },
].map(mapChild)

export const DEFAULT_FOR_PARENTS = {
  id: 'ForParents',
  title_en: 'For Parents',
  title_ar: 'لأولياء الأمور',
  slug: null,
  url: null,
  children: FOR_PARENTS_CHILDREN,
}
